import { render, staticRenderFns } from "./vLabeledCheckbox.vue?vue&type=template&id=196d7d60&"
import script from "./vLabeledCheckbox.vue?vue&type=script&lang=js&"
export * from "./vLabeledCheckbox.vue?vue&type=script&lang=js&"
import style0 from "./vLabeledCheckbox.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports